<ng-container *ngIf="isAlternateInputModalVisible" [appWorkflowItemData]="modalData">
	<div *ngFor="let question of defaultGroupConfiguration.items, let i = index" nz-col class="gutter-row mb-3">
		<ng-container *ngIf="itemsEnabled[i]">
			<h3>{{ question.title }}</h3>
			<div markdown *ngIf="question.description" [data]="question.description"></div>
			<workflow-questionnaire-block-question
					(valid)="setValid($event, i)"
					[group]="defaultGroupConfiguration"
					[blockMissingValueKey]="question.missingValueKey"
					[question]="question" [finishedAndLocked]="finishedAndLocked"
					[softLocked]="softLocked"
					[hasWorkflowWritePermission]="hasWorkflowWritePermission"
					[validationLevel]="validationLevel"
					[modalView]="false">
			</workflow-questionnaire-block-question>
		</ng-container>
	</div>
</ng-container>
